export default function(array, filter, visitor) {
  if (array) {
    var i = 0, n = array.length, t;
    if (filter) {
      for (; i<n; ++i) {
        if (t = filter(array[i])) visitor(t, i, array);
      }
    } else {
      array.forEach(visitor);
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/visitArray.js
// module id = 1550
// module chunks = 0